import { createSlice, createEntityAdapter } from "@reduxjs/toolkit";

import {
  doGetAllCompanyAdmins,
  doCreateCompanyAdmin,
  doUpdateCompanyAdmin,
  doGetAllPartnerCompanyAdmins,
  doCreatePartnerCompanyAdmin,
  doUpdatePartnerCompanyAdmin,
} from "./thunk";

const companyAdminsAdapter = createEntityAdapter({
  selectId: item => item._id,
  sortComparer: (a, b) => b.createdAt.localeCompare(a.createdAt),
});

const companyAdminSlice = createSlice({
  name: "companyAdmin",
  initialState: {
    isFetching: false,
    metadata: {},
    entities: [],
    ids: [],
  },
  reducers: {},
  extraReducers: builder => {
    builder.addCase(doGetAllCompanyAdmins.pending, state => {
      state.isFetching = true;
    });
    builder.addCase(doGetAllCompanyAdmins.fulfilled, (state, action) => {
      const { companyAdmins, meta } = action.payload;
      state.isFetching = false;
      state.metadata = meta;
      companyAdminsAdapter.setAll(state, companyAdmins);
    });
    builder.addCase(doGetAllCompanyAdmins.rejected, state => {
      state.isFetching = false;
    });
    builder.addCase(doCreateCompanyAdmin.pending, state => {
      state.isFetching = true;
    });
    builder.addCase(doCreateCompanyAdmin.fulfilled, (state, action) => {
      state.isFetching = false;
      companyAdminsAdapter.upsertOne(state, action.payload);
    });
    builder.addCase(doCreateCompanyAdmin.rejected, state => {
      state.isFetching = false;
    });
    builder.addCase(doUpdateCompanyAdmin.pending, state => {
      state.isFetching = true;
    });
    builder.addCase(doUpdateCompanyAdmin.fulfilled, (state, action) => {
      state.isFetching = false;
      companyAdminsAdapter.upsertOne(state, action.payload);
    });
    builder.addCase(doUpdateCompanyAdmin.rejected, state => {
      state.isFetching = false;
    });
    builder.addCase(doGetAllPartnerCompanyAdmins.pending, state => {
      state.isFetching = true;
    });
    builder.addCase(doGetAllPartnerCompanyAdmins.fulfilled, (state, action) => {
      const { companyAdmins, meta } = action.payload;
      state.isFetching = false;
      state.metadata = meta;
      companyAdminsAdapter.setAll(state, companyAdmins);
    });
    builder.addCase(doGetAllPartnerCompanyAdmins.rejected, state => {
      state.isFetching = false;
    });
    builder.addCase(doCreatePartnerCompanyAdmin.pending, state => {
      state.isFetching = true;
    });
    builder.addCase(doCreatePartnerCompanyAdmin.fulfilled, (state, action) => {
      state.isFetching = false;
      companyAdminsAdapter.upsertOne(state, action.payload);
    });
    builder.addCase(doCreatePartnerCompanyAdmin.rejected, state => {
      state.isFetching = false;
    });
    builder.addCase(doUpdatePartnerCompanyAdmin.pending, state => {
      state.isFetching = true;
    });
    builder.addCase(doUpdatePartnerCompanyAdmin.fulfilled, (state, action) => {
      state.isFetching = false;
      companyAdminsAdapter.upsertOne(state, action.payload);
    });
    builder.addCase(doUpdatePartnerCompanyAdmin.rejected, state => {
      state.isFetching = false;
    });
  },
});

export const {
  selectAll: selectAllCompanyAdmins,
  selectById: selectCompanyAdminById,
  selectIds: selectCompanyAdminIds,
} = companyAdminsAdapter.getSelectors(state => state.companyAdmin);

const { reducer: companyAdminReducer } = companyAdminSlice;
export default companyAdminReducer;
